import styled from "styled-components";

export const Container = styled.div`
--bg-color: #59DDB1;
display: flex;
padding: 3px 8px;
border-radius: 23px;
font-family: 'Open Sans', sans-serif;
font-weight: 400;
font-size: 12px;
line-height: 12px;
color: white;
background-color: var(--bg-color);
`

